import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { openCustomerPortal } from "../services/stripe";
import { isProUser } from "../utils/entitlements";

function PlanCard({ profile }) {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const pro = isProUser(profile);
  const count = profile?.garageCars?.length || 0;

  const manage = async () => {
    try { setLoading(true); setError(""); await openCustomerPortal(); }
    catch (err) { setError(err.message || "Unable to open subscription management."); setLoading(false); }
  };

  return (
    <section style={cardStyle} aria-label="Garage plan">
      <p style={labelStyle}>Garage Plan</p>
      <h2 style={titleStyle}>{pro ? "MyBuildID Pro" : "Free"}</h2>
      <p style={usageStyle}>{pro ? "Unlimited Builds" : `${Math.min(count, 1)} / 1 Builds Used`}</p>
      {pro ? (
        <button type="button" disabled={loading} onClick={manage} style={buttonStyle}>{loading ? "Opening…" : "Manage Subscription"}</button>
      ) : (
        <button type="button" onClick={() => navigate("/pro")} style={buttonStyle}>Go Pro</button>
      )}
      {error && <p role="alert" style={errorStyle}>{error}</p>}
    </section>
  );
}

const cardStyle = { background: "#181818", border: "1px solid #2a2a2a", borderRadius: "20px", padding: "22px", marginBottom: "20px" };
const labelStyle = { margin: "0 0 8px", color: "#888", fontSize: "12px", fontWeight: 800, textTransform: "uppercase", letterSpacing: "1px" };
const titleStyle = { margin: 0, fontSize: "26px" };
const usageStyle = { margin: "10px 0 18px", color: "#bbb" };
const buttonStyle = { minHeight: "46px", padding: "0 18px", border: 0, borderRadius: "12px", background: "#e10600", color: "white", fontWeight: 800, cursor: "pointer" };
const errorStyle = { color: "#ff8b87", marginBottom: 0 };
export default PlanCard;
